var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "form-block",
    class: _vm.generalClasses
  }, [_vm.showHeader ? _c('div', {
    staticClass: "form-block__header",
    class: {
      'form-block__header--not-visible': !_vm.isBlockVisible,
      'form-block__header--column': !!_vm.button
    }
  }, [_vm.title || _vm.$slots.title ? _c('h3', {
    class: _vm.titleClasses
  }, [_vm.tip ? _c('div', {
    class: _vm.tipClasses
  }, [_c('UiTip', {
    attrs: {
      "position": _vm.tip.position,
      "message": _vm.tip.message,
      "tip-styles": _vm.tip.styles
    }
  })], 1) : _vm._e(), _vm._t("title", function () {
    return [_c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.title)
      }
    }), _vm.titleCounter ? _c('span', {
      staticClass: "form-block__counter"
    }, [_vm._v("(" + _vm._s(_vm.titleCounter) + ")")]) : _vm._e()];
  })], 2) : _vm._e(), _vm.showVisibilityToggle ? _c('UiButton', {
    attrs: {
      "size": "xs",
      "type": "link",
      "label": _vm.isBlockVisible ? 'Свернуть' : 'Показать',
      "append-icon": _vm.isBlockVisible ? 'drop-up' : 'drop-down'
    },
    on: {
      "click": _vm.toggleVisibility
    }
  }) : _vm._e(), _vm.button ? _c('UiButton', {
    attrs: {
      "label": _vm.getFieldPropertyFn(_vm.button, 'label'),
      "disabled": _vm.getFieldPropertyFn(_vm.button, 'readonly'),
      "pending": _vm.getFieldPropertyFn(_vm.button, 'pending'),
      "size": _vm.getFieldPropertyFn(_vm.button, 'size'),
      "type": _vm.getFieldPropertyFn(_vm.button, 'btnType'),
      "block": _vm.getFieldPropertyFn(_vm.button, 'block', _vm.mobile)
    },
    on: {
      "click": function () {
        return _vm.onClick(_vm.button);
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _c('div', [_vm._t("additionalSlot")], 2), _c('div', {
    directives: [{
      name: "toggle-height",
      rawName: "v-toggle-height"
    }],
    ref: "toggleHeightTarget",
    staticClass: "form-block__content"
  }, [_vm._t("default")], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }